import './index.css'
import star from '../../../assets/star.svg'
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

export const ListChefCard = ({data, standby, fungsi}) => {

    const history = useNavigate()
    const [pindah, setPindah] = useState(false)

    useEffect(()=>{
        
        if(pindah===true){
            setTimeout(function() {
                history("/category/chefList/detailChef");
           }, 500);
        }
    },[pindah])

    return (
        <div className='listchefcardcontainer'>
            <div onClick={() => {fungsi();setPindah(true)}} className='kontenlistchefcard'>
                <img alt="gambarlistchef" src={data.gambar} class="gambarlistchef"></img>
                <div className='kontainerdetaillistchef'>
                    <div className='kontaineratas'>
                        <div className='kontainerkiri'>
                            <p className='textdatanama'>{data.nama}</p>
                        </div>
                        
                        <div className='kontainerkanan'>
                            <img className='iconlistchef' alt="iconrating" src={star}></img>
                            <p className='texticonlistchef'>{data.rating}</p>
                        </div>
                    </div>
                    <div className='kontainerlistcuisine'>
                        {data.jenis.map((post) => {
                            if(post === data.jenis[0]){
                                return (
                                    <p className='textlistcuisine'>{post} Cuisine</p>
                                    )
                            }else{
                                return (
                                    <p className='textlistcuisine'>, {post} Cuisine</p>
                                    )
                            }
                })}
                    </div>
                    
                    <p className='textareachef'>{data.area}</p>

                    <div className='kontainerlistchefbawah'>
                        <p className='textstartfrom'>Start from</p>
                        <p className='texthargachef'>IDR {data.harga}/PAX</p>
                    </div>
                </div>
            </div>
        </div>
    )
  }